export default __webpack_public_path__ + "static/media/TransNations.93ae3d38d18aeb98d5be4bc0153c83ba.webp";